import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, ImageMapa, SubContainerButtonMapa, HeaderTitle, SubContainerButton, ContainerField, SubContainerField,ContainerImage, ContainerFieldLocation, ContainerContent, ContainerBottom, ContainerBottomMapButton } from './style'
import { MultiSelect } from '../../components/MultiSelect/MultiSelect'
import Input from '../../components/Input/Input'
import Button from '../../components/Button/Button'
import logo from '../../assets/images/logo.png'
import imgMapa from '../../assets/images/mapa.png'
import disableBrowserBackButton from 'disable-browser-back-navigation'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { callGeolocation, checkGeolocation } from '../../helpers/geo'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
//sagas
import { fetchCompaniesStart, companiesReset }  from '../../services/store/reducers/endpoints/companies'
import { fetchClientsStart, clientsReset }  from '../../services/store/reducers/endpoints/clients'
import { fetchUnitsStart, unitsReset }  from '../../services/store/reducers/endpoints/units'
import { fetchFindCoordsByUnitStart, findCoordsByUnitReset }  from '../../services/store/reducers/endpoints/findCoordsByUnit'
import { configurationReset, configurationSave }  from '../../services/store/reducers/configuration'
import { homeSave }  from '../../services/store/reducers/home'

class Configuration extends PureComponent{
  
  state = {
    company: '',
    client: '',
    unit: '',
    lat: '',
    lng: '',
    raio: '',
    sended: false,
    sendedFindCoord: false
  }
  
  
  UNSAFE_componentWillMount () {    
    
    this.props.fetchCompaniesStart()
    disableBrowserBackButton()
    this.populateField()
  }

  populateField = () => {
    const { configuration } = this.props
    this.setState(
      {
        company: configuration.company,
        client: configuration.client,
        unit: configuration.unit,
        lat: configuration.lat,
        lng: configuration.lng,
        raio: configuration.raio
      })
  }

  salvar =  () => {
    if(this.isCamposValidos()) {
      let obj = {
        company: this.state.company,
        client: this.state.client,
        unit: this.state.unit,
        lat: this.state.lat,
        lng: this.state.lng,
        raio: this.state.raio
      }
       //internet
       if (!window.navigator.onLine) {
        window.location.href='/report-user?message=-&errorCode=1'
          return
        }
     
      //location
      checkGeolocation().then((result) => {
        if(result){
          this.setState({sended: true})
          this.props.configurationSave(obj)
          this.props.homeSave({companyName: '', company: obj.company.value, senha: ''}) 
        }else{
          window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
        }
      })
    }
  }

  isCamposValidos = () => {
    if (!this.state.company) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Empresa não informada.'})
      return false
    }

    if (!this.state.client) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Cliente não informado.'})
      return false
    }

    if (!this.state.unit) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Unidade não informada.'})
      return false
    }

    if (!this.state.lat) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Latitude não calculada.'})
      return false
    }

    if (!this.state.lng) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Longitude não calculada.'})
      return false
    }

    if (!this.state.raio) {
      this.setState({titleModal: 'Atenção!', messageModal: 'O raio deve ser informado.'})
      return false
    }

    if (isNaN(this.state.raio)) {
      this.setState({titleModal: 'Atenção!', messageModal: 'O raio deve ser um número.'})
       return false
    }

    return true
  }

  buscarLatAndLng = () => {
    if( 
      (this.state.company === null || this.state.company === '')
      || (this.state.client === null || this.state.client === '')
      || (this.state.unit === null || this.state.unit ===  '')
      ){
      let message = ''
      if((this.state.company === null || this.state.company === '')){
        message += 'Empresa não informada '
      }
      if(message === '' && ( this.state.client === null || this.state.client === '')){
        message += 'Cliente não informado '
      }
      if(message === '' && (this.state.unit === null || this.state.unit === '')){
        message += 'Unidade não informado '
      }
      message += ''
      this.setState({titleModal:'Atenção', messageModal: message})
      return
    }
    checkGeolocation().then((result) => {
      if(result){
        callGeolocation(0, 0, (position, distancia) => {
          this.setState({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            raio: position.coords.accuracy
          
          })
        })
      }else{
        window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
      }
    })
    
  }

  resposta = () => {
    this.setState({sended: false})
    checkGeolocation().then((result) => {
      if(result){
        window.location.href = '/login-adm'
      }else{
        window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
      }
    })
    

  }

  voltar = () => {
    if (!window.navigator.onLine) {
      window.location.href='/report-user?message=-&errorCode=1'
      return
    }
    window.location.href = '/home'
  }

  buscaClientes(empresa) {
    this.props.fetchClientsStart({empresaId: empresa})
  }

  buscaUnidades(cliente) {
    this.props.fetchUnitsStart({empresaId: this.state.company.value, clientId: cliente})
  }
  handleKeyPress = (event) => {
    if(
      ["-", "+"].includes(event.key)
    ) {
      event.preventDefault();
    }
    
    if(event.key === 'Enter'){
      this.buscar()
    }
  }

  buscaCoords = (unit) => {
    this.props.findCoordsByUnitReset()
    this.setState({sendedFindCoord: true})
    this.props.fetchFindCoordsByUnitStart({unit: unit})
  }

  respostaBuscaCoords = () => {
    const { sagaFindCoordsByUnit } = this.props
    this.setState({sendedFindCoord: false})

    if(sagaFindCoordsByUnit.latitude === null){
      this.setState({ lat: ''})
    }else{
      this.setState({ lat: sagaFindCoordsByUnit.latitude})
    }

    if(sagaFindCoordsByUnit.longitude === null){
      this.setState({ lng: ''})
    }else{
      this.setState({ lng: sagaFindCoordsByUnit.longitude})
    }

    if(sagaFindCoordsByUnit.tolerancia === null){
      this.setState({ raio: ''})
    }else{
      this.setState({ raio: sagaFindCoordsByUnit.tolerancia})
    }
    
  }

  cleanFieldsLocation = () => {
    this.setState({ lat: '', lng: '', raio: ''})
  }
 
  render() {
    const {sagaFindCoordsByUnit, sagaCompanies, sagaClients, sagaUnits, configuration} = this.props
    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>
        <CurrentTime></CurrentTime>
        <ContainerContent>
          <HeaderTitle>Configuração</HeaderTitle>
        </ContainerContent>
        
        <ContainerContent>
          <ContainerField>
          <MultiSelect options={ !sagaCompanies ? [] : sagaCompanies.map((val) => {
            return {
              value: val.codigoEmpresaSAR,
              label: val.nome
            }
          }) } 
          value={ this.state.company }
          onChange= { (event) => {
            this.setState({client: null, unit: null})
            this.buscaClientes(event.value) 
            this.setState({company: event})
            this.cleanFieldsLocation()
          }}
          placeholder= {'Empresa'}
          />
          </ContainerField>
          <ContainerField>
            <MultiSelect options={ !sagaClients ? [] : sagaClients.map((val) => {
              return {
                value: val.codigoClienteSAR,
                label: val.nome
              }
            }) } 
            onKeyPress={(event) => { this.handleKeyPress(event)}}
            onChange= { (event) => { 
              this.setState({unit: null})
              this.buscaUnidades(event.value)
              this.setState({client: event})
              this.cleanFieldsLocation()
            }}
            value={this.state.client}
            placeholder='Cliente'/>
          </ContainerField>
          <ContainerField>
            <MultiSelect options={ !sagaUnits ? [] : sagaUnits.map((val) => {
              return {
                value: val.codigoUnidadeSAR,
                label: val.nome
              }
            }) } 
            value={this.state.unit}
            onChange= { (event) => { 
              this.setState({unit: event}) 
              this.buscaCoords(event.value)
            }}
            placeholder='Unidade' />
          </ContainerField>
          <ContainerBottom>

          <div>
          <ContainerFieldLocation>
            <SubContainerField>
              <Input type='text'
              placeholderAlign='left'
              opacity={0.7}
              textAlign={'right'}
              disabled={true} 
              value={ this.state.lat }
               placeholder='Latitude' 
               autoComplete='off' 
               onChange={(event)=>{
                 console.log('onChange latitude->', event)
                this.setState({ lat: event.value})
               }}
               />
               <span>Graus decimais</span>
            </SubContainerField>
          </ContainerFieldLocation>
          <ContainerFieldLocation>
          <SubContainerField>
            <Input type='text'
            placeholderAlign='left'  
            opacity={0.7}
            textAlign={'right'}
            disabled={true} 
            value={ this.state.lng }
            placeholder='Longitude' autoComplete='off' 
            onChange={(event)=>{
              console.log('onChange latitude->', event)
             this.setState({ lng: event.value})
            }}
            />
            <span>Graus decimais</span>
          </SubContainerField>
         
        </ContainerFieldLocation>
        
        <ContainerFieldLocation>
        <SubContainerField>
          <Input
          placeholderAlign='left' 
          textAlign={'right'}
          onChange= { (event) => { this.setState({raio: event.target.value}) }} 
          value= {this.state.raio}
          placeholder='Tolerância' type='number' autoComplete='off' />
          <span>Metros</span>
        </SubContainerField>
      </ContainerFieldLocation>
      </div>
      <ContainerBottomMapButton>

        <SubContainerButtonMapa>
          <ImageMapa src={imgMapa} onClick={ () => { this.buscarLatAndLng() }}/>
        </SubContainerButtonMapa>
      

      </ContainerBottomMapButton>
      </ContainerBottom>
        </ContainerContent>
        <SubContainerButton>
          <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.voltar() }}>Voltar</Button>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.salvar() }}>Salvar</Button>
        </SubContainerButton>
        {
          configuration &&
          this.state.sended &&
          sagaCompanies &&
          this.resposta()
        }
        {
          sagaFindCoordsByUnit &&
          this.state.sendedFindCoord &&
          this.respostaBuscaCoords()
        }
        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlert 
            title={this.state.titleModal} 
            message={ this.state.messageModal} 
            onClick={() => { this.setState({messageModal: '', titleModal: ''}) } }
            />
        }
        {
          /* Futura geração de programadores, foi feita esta gambiarra por que não tinhamos 1 semana para configurar o Docker. */
        }
        <span style={{
            position: 'relative',
            backgroundColor:'#1594A5',
            width: '100%',
            marginTop: '-80px',
            color: '#1594A5',
            zIndex: 1
          }}>
          <br/>.<br/>.<br/>.<br/>
        </span>
     </Container>
    )
  }
}

//Os dados
const mapStateToProps = state => ({
  company: state.home.company,
  configuration: state.configuration,
  sagaCompanies: state.sagaCompanies.data,
  sagaClients: state.sagaClients.data,
  sagaUnits: state.sagaUnits.data,
  sagaFindCoordsByUnit: state.sagaFindCoordsByUnit.data,
  appConfig: state.appConfig
})
//Chamadas dos eventos
const mapDispatchToProps = dispatch => ({
  fetchCompaniesStart: (mss) => dispatch(fetchCompaniesStart(mss)),
  companiesReset: (mss) => dispatch(companiesReset(mss)),

  fetchClientsStart: (mss) => dispatch(fetchClientsStart(mss)),
  clientsReset: () => dispatch(clientsReset()),

  fetchUnitsStart: (mss) => dispatch(fetchUnitsStart(mss)),
  unitsReset: (mss) => dispatch(unitsReset(mss)),

  fetchFindCoordsByUnitStart: (mss) => dispatch(fetchFindCoordsByUnitStart(mss)),
  findCoordsByUnitReset: (mss) => dispatch(findCoordsByUnitReset(mss)),

  configurationReset: () => dispatch(configurationReset()),
  configurationSave: (value) => dispatch(configurationSave(value)),
  homeSave: (value) => dispatch(homeSave(value)),
})
//Mapeamento entre React e Redux
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Configuration)